module.exports = __webpack_public_path__ + "static/media/IconoCompetenciasGenericas.c70a4575.svg";